import clientImg1 from "../images/andrew_david.png";
import clientImg4 from "../images/mauren.png";
import clientImg5 from "../images/jordy_backes.png";
import clientImg6 from "../images/client_img6.png";

const wordsClientData = [
  {
    id: 1,
    clientImg: clientImg4,
    clientName: "Mauren kaufmann",
    clientOccupation: "Principal Shopify Consultant and Shopify Expert",
    description:
      "I have worked with eQuest Solutions on various web projects (mainly Shopify stores) since 2018 and I've always had successful results. Since I found them I have not had to shop for developers anywhere else. The communication is great, their professionalism, they are always up to date with new trends, they give us great advise on how to approach new challenges and they are reliable and deliver on time. I recommend going to eQuest for all your developer needs.PS: when I visited them on a business trip to India they were the best hosts :)",
  },
  {
    id: 2,
    clientImg: clientImg5,
    clientName: "Jordy Backes",
    clientOccupation: "eComm Era",
    description:
      "I’ve been working with eQuest for a year now. I’ve worked with other development agencies. It’s easy to say that eQuest has been the best to work with. The difference is mostly in the communication, which is prompt and clear. When I am faced with an urgent situation, eQuest is there to help me out. This reliability is a must for me and I’ve found it in eQuest Solutions.",
  },
  {
    id: 3,
    clientImg: clientImg6,
    clientName: "Otto Mouton",
    clientOccupation: "Jimmy Joy",
    description:
      "We’re still very pleased with our partnership after almost 3 years. We’ve experience absolutely zero problems with the time-zone difference or language barriers, it has been such a smooth ride. Anything from small edits to complete custom builds, we know we can count on them!",
  },
  {
    id: 4,
    clientImg: clientImg1,
    clientName: "Andrew Akosile & David Pajda",
    clientOccupation: "Cardsplug",
    description:
      "Our partnership has been very successfully and we cannot imagine anyone else doing the work that eQuest Solutions have done for us. Together have built the most advance website in our industry with no one else coming close. We know our ideas can easily be developed into reality by the whole of eQuest Solutions team.",
  },
];

export default wordsClientData;
